import '../../style/index.less'
import './index.less'



// WEBPACK FOOTER //
// ./components/switch/style/index.js